module.exports = __webpack_public_path__ + "img/mall_02.b5bda90e.png";